export const INIT_RESET_PASSWORD_REQUEST = 'INIT_RESET_PASSWORD_REQUEST';

export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_REQUEST_FULFILLED = 'RESET_PASSWORD_REQUEST_FULFILLED';
export const RESET_PASSWORD_REQUEST_REJECTED = 'RESET_PASSWORD_REQUEST_REJECTED';

export const RESET_PASSWORD = 'RESET_PASSWORD';
export const RESET_PASSWORD_FULFILLED = 'RESET_PASSWORD_FULFILLED';
export const RESET_PASSWORD_REJECTED = 'RESET_PASSWORD_REJECTED';
